import { useEffect, useState } from 'react';
import {
  closeSearchConnection,
  getSearchClients,
  getSearchHasMore,
  getSearchIsLoadingMore,
  getSearchLoadMoreError,
  getSearchStatus,
  loadMoreSminexClubClients,
  retrySminexClubLoadMore,
  searchSminexClubClients,
  subscribeSearch,
} from './store';
import { SminexClubSearchClient, SminexClubSearchStatus } from './types';

export const useSminexClubSearch = () => {
  const [clients, setClients] = useState<SminexClubSearchClient[]>(getSearchClients);
  const [status, setStatus] = useState<SminexClubSearchStatus>(getSearchStatus);
  const [hasMore, setHasMore] = useState<boolean>(getSearchHasMore);
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(getSearchIsLoadingMore);
  const [loadMoreError, setLoadMoreError] = useState<boolean>(getSearchLoadMoreError);

  useEffect(() => {
    return subscribeSearch((state) => {
      setClients(state.clients);
      setStatus(state.status);
      setHasMore(state.hasMore);
      setIsLoadingMore(state.isLoadingMore);
      setLoadMoreError(state.loadMoreError);
    });
  }, []);

  return {
    clients,
    status,
    hasMore,
    isLoadingMore,
    loadMoreError,
    search: searchSminexClubClients,
    cancel: closeSearchConnection,
    loadMore: loadMoreSminexClubClients,
    retryLoadMore: retrySminexClubLoadMore,
  };
};
